<h2 mat-dialog-title>Remove {{ data.ppa.name }}?</h2>

<div mat-dialog-content>
  <p class="summary">
    {{ data.ppa.type_of_ppa }}<ng-container *ngIf="ppaPlace(data.ppa.Locations?.[0]) as place"> · {{ place }}</ng-container>
    · {{ data.ppa.corper_count }} corp member{{ data.ppa.corper_count === 1 ? '' : 's' }}
    · {{ data.ppa.review_count }} review{{ data.ppa.review_count === 1 ? '' : 's' }}
  </p>

  <div class="field-label" id="remove-reason-label">Why?</div>
  <mat-radio-group [formControl]="category" aria-labelledby="remove-reason-label" class="reasons">
    <mat-radio-button *ngFor="let c of categories" [value]="c.value">
      {{ c.value === 'duplicate' ? 'Duplicate of another PPA' : c.label }}
    </mat-radio-button>
  </mat-radio-group>

  <!-- Merge -->
  <section *ngIf="isMerge" class="merge" aria-labelledby="merge-heading">
    <div class="field-label" id="merge-heading">Merge into</div>
    <p class="hint">
      Its corp members, reviews and saves move to the PPA you pick, and its old links go there. A merge can't be undone.
    </p>

    <div *ngIf="loadingSimilar" class="hint">Looking for likely duplicates…</div>
    <div *ngIf="!loadingSimilar && similar.length" class="hint">Likely duplicates in its LGA:</div>
    <ul class="targets">
      <li *ngFor="let target of similar">
        <button type="button" class="target" [class.target--picked]="into?.id === target.id" [attr.aria-pressed]="into?.id === target.id" (click)="pick(target)">
          <span class="target__name">{{ target.name }}</span>
          <span class="target__meta">
            {{ target.type_of_ppa }}<ng-container *ngIf="ppaPlace(target.Locations?.[0]) as place"> · {{ place }}</ng-container>
            · {{ target.corper_count }} corp member{{ target.corper_count === 1 ? '' : 's' }}
          </span>
        </button>
      </li>
    </ul>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>{{ similar.length ? 'Or find another PPA' : 'Find the PPA it duplicates' }}</mat-label>
      <mat-icon matPrefix class="mr-2 text-gray-400">search</mat-icon>
      <input matInput [formControl]="search" placeholder="Name or type…" />
    </mat-form-field>
    <ul class="targets" *ngIf="searchResults.length">
      <li *ngFor="let target of searchResults">
        <button type="button" class="target" [class.target--picked]="into?.id === target.id" [attr.aria-pressed]="into?.id === target.id" (click)="pick(target)">
          <span class="target__name">{{ target.name }}</span>
          <span class="target__meta">
            {{ target.type_of_ppa }}<ng-container *ngIf="ppaPlace(target.Locations?.[0]) as place"> · {{ place }}</ng-container>
            · {{ target.corper_count }} corp member{{ target.corper_count === 1 ? '' : 's' }}
          </span>
        </button>
      </li>
    </ul>
  </section>

  <!-- Delete -->
  <section *ngIf="category.value && !isMerge" class="delete">
    <p class="hint">
      It's hidden everywhere right away<ng-container *ngIf="data.ppa.corper_count">, and its {{ data.ppa.corper_count }} corp member{{ data.ppa.corper_count === 1 ? ' is' : 's are' }} told to pick their PPA again</ng-container>.
      You can restore it from "Recently deleted" for {{ retention }} - after that it's gone for good, with its reviews.
    </p>
    <mat-checkbox *ngIf="canBlockName" [formControl]="blockName">Don't let anyone add this name again</mat-checkbox>
  </section>

  <mat-form-field *ngIf="category.value" appearance="outline" class="w-full mt-3">
    <mat-label>{{ noteRequired ? 'Why are you removing it?' : 'Note (optional)' }}</mat-label>
    <textarea matInput [formControl]="note" rows="2" maxlength="1000" [required]="noteRequired"></textarea>
  </mat-form-field>
</div>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button color="warn" [disabled]="!canConfirm" (click)="confirm()">
    {{ isMerge ? (into ? 'Merge into ' + into.name : 'Merge') : 'Delete' }}
  </button>
</mat-dialog-actions>
